const defaultProps = {
  size: 'md',
}

const sizes = {
  xs: { h: 20, w: 20, p: '2px' },
  sm: { h: 24, w: 24, p: '4px' },
  md: { h: 32, w: 32, p: '8px' },
  lg: { h: 40, w: 40, p: '12px' },
}

export default {
  defaultProps,
  sizes,
}
